/*
 * @Author: wblijinyang
 * @FilePath: /code/mall-fe/src/views/web/product/context/TradeAgreement.tsx
 * @Description: 交易规则context
 */
import { createContext, useContext, useState, useMemo, useEffect } from 'react';
import { AgreementType } from 'libs/enums';

const TradeAgreementContext = createContext(null);

const TradeAgreementContextProvider = ({ children, skuDetail }) => {
  const active = useMemo(() => {
    let activeTradeAgreement = {};
    const alternative =
      skuDetail?.tradeAgreementEntityList?.filter(
        (v) => v.tradeAgreementScope !== AgreementType.beCurrent,
      ) || [];
    if (skuDetail?.tradeAgreementEntityList?.length) {
      // 找出活跃的交易规则
      activeTradeAgreement = alternative.find((v) => v.active);

      if (!activeTradeAgreement) {
        // 没有找到活跃的交易规则,优先从内部交易规则中取默认值
        activeTradeAgreement = alternative.length
          ? alternative[0]
          : skuDetail?.tradeAgreementEntityList[0];
      }
    }
    return activeTradeAgreement;
  }, [skuDetail]);

  const [selectTradeAgreement, setSelectTradeAgreement] = useState(active);

  useEffect(() => {
    setSelectTradeAgreement(active);
  }, [active, setSelectTradeAgreement]);

  const tradeAgreementData = useMemo(
    () => ({ selectTradeAgreement, setSelectTradeAgreement }),
    [selectTradeAgreement, setSelectTradeAgreement],
  );

  return (
    <TradeAgreementContext.Provider value={tradeAgreementData}>
      {children}
    </TradeAgreementContext.Provider>
  );
};

const useTradeAgreementContext = () => {
  const context = useContext(TradeAgreementContext);
  if (context === undefined) {
    throw new Error('useTradeAgreementContext must be used within a TradeAgreementContextProvider');
  }
  return context;
};

export { TradeAgreementContextProvider, useTradeAgreementContext };
